<template>
    <div>
        <b-card no-body v-show="mostrarDirfs">
            <b-card-header>
                <h5>DIRFs</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblDirfs"
                    :itens="dirfs"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <btn-importar-dirf
                            @obterDirfsAtualizadas="obterDirfs()"
                            class="float-right"
                        ></btn-importar-dirf>
                    </template>
                    <template slot="cnpj" slot-scope="data">
                        <span v-if="data.cnpj.length == 14">{{ data.cnpj | toCnpj }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary" v-if="$temAcessoView('DIRFS-02')">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharDirf(data.dirfId)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import DirfsServicos from './DirfsServicos'
import BtnImportarDirf from './BtnImportarDirf'

export default {
	//   props: {
	//     expressoPlanilhas: {
	//       type: Array,
	//       default: () => ([])
	//     }
	//   },
	components: {
		BtnImportarDirf
	},

	data() {
		return {
			dirfs: [],
			campos: [
				{
					key: 'anoReferencia',
					label: 'Ano Referência',
					sortable: true,
					filterable: true
				},
				{
					key: 'anoCalendario',
					label: 'Ano Calendário',
					sortable: true,
					filterable: true
				},
				{
					key: 'cnpj',
					label: 'CNPJ',
					sortable: true,
					filterable: true
				},
				{
					key: 'nomePagadora',
					label: 'Fonte Pagadora',
					sortable: true,
					filterable: true
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		obterDirfs(filtro) {
			this.$store.dispatch('addRequest')
			DirfsServicos.obterTodas().then(response => {
				if (response) {
					if (response.success) {
						this.dirfs = response.data
					} else {
						this.$toast.error(
							'Erro ao obter as DIRFs',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		detalharDirf(dirfId) {
			this.$router.push({
				name: 'Dirfs_Detalhar',
				params: {
					dirfId
				}
			})
		}
	},

	created() {
		this.obterDirfs()
	},

	computed: {
		mostrarDirfs() {
			return this.$route.name == 'Dirfs'
		}
	},

	watch: {}
}
</script>
